import React, { FunctionComponent, useEffect, useState } from "react";
import styles from "./UnlockBoosterLeadsTooltip.module.css";
import { connect, useDispatch } from "react-redux";
import BoosterLock from "../../../Assets/Images/booster-lock.png";
// import { updateTheme } from "../../Redux/actions";
import { openCustomMMBURL, openCustomMMBURLWithGA } from "../../../Values/utils";
import CloseIcon from "@mui/icons-material/Close";
import axiosHandler from "../../../Services/axiosHandler";
import { url } from "../../../Values/constants";
import {
  googleAnalyticsCTAClick,
  googleAnalyticsTabClick,
} from "../../../Services/users";
import { maskedBossterMonthWise } from "../../../Services/contacts";

type props = {
  setShowUnlockBoosterTooltip: any;
  user: any;
  leadData: any;
};

const UnlockBoosterLeadsTooltip: FunctionComponent<props> = ({
  setShowUnlockBoosterTooltip,
  user,
  leadData,
}) => {
  const [autoToken, setAutoToken] = React.useState("");
  const [showMessage1, setShowMessage1] = useState(true);
  const [showMessage2, setShowMessage2] = useState(false);
  const [last30DaysCount, setLast30DaysCount] = useState("");

  useEffect(() => {
    let userData: any = localStorage.getItem("user");
    let parsedUser = JSON.parse(userData);
    if (parsedUser.autoToken) {
      setAutoToken(parsedUser.autoToken);
    }
  }, []);

  // const fetchData = async () => {
  //   const now = new Date();
  //   const endDate = now.toISOString();

  //   const startDateObj = new Date();
  //   startDateObj.setDate(now.getDate() - 30);
  //   const startDate = startDateObj.toISOString();

  //   const created_at = [startDate, endDate];
  //   const res = await axiosHandler.post(url + "/leads/contacttotalcount", {
  //     uid: user.uid,
  //     leadFilter: {
  //       transfer_status: [false],
  //       lead_sub_type: ["Masked Booster Leads"],
  //       created_at: created_at,
  //     },
  //     leadUserFilter: {},
  //     role: true,
  //   });

  //   setLast30DaysCount(res.data.total);
  //   //   setTotalCounts(res.data.total);
  // };

   useEffect(() => {
        const fetchLeadCount = async () => {
          try {
            const res:any = await maskedBossterMonthWise();
            if (res?.data?.count) {
              setLast30DaysCount(res.data.count);
            }
          } catch (error) {
            console.error("Error fetching masked booster count", error);
          }
        };
    
        fetchLeadCount();
      }, []);

  // useEffect(() => {
  //   fetchData();
  // }, []);
  useEffect(() => {
    if (showMessage1 === true) {
      googleAnalyticsTabClick(
        "Contact Screen - Masked Booster Tool Tip 1st layer",
        user
      );
    } else if (showMessage2 === true) {
      googleAnalyticsTabClick(
        "Contact Screen - Masked Booster Tool Tip 2nd layer",
        user
      );
    }
  }, [showMessage1, showMessage2]);

  const openUrl = async () => {
    try {
      googleAnalyticsCTAClick(
        "Know More",
        "Contact Screen - Masked Booster Tool Tip",
        user
      );
      openCustomMMBURL(autoToken,"bricks/boosterDashboard.html?showPopup=true&intf=agent_mon_readPro_Know_More&sr=Contact_Screen_Masked_Booster_Tool_Tip&pfm=WEB")
    } catch (error) {
      console.error("Error fetching masked booster count", error);
    }
  };
  return (
    <>
      <div className={styles.unlockBoosterLeadsTooltip}>
        <div className={styles.unlockBoosterLeadsTooltipT}>Sanjeev has shown interest in your property {leadData.property_id?`id - ${leadData.property_id}`:""}</div>
        {/* <div className={styles.unlockBoosterLeadsTooltipTxt}>Sanjeev has shown interest in your property id - XXXX </div> */}
        <div className={styles.unlockBoosterLeadsTooltipTxt}>Your listing received <span className={styles.TextSemibold}>{last30DaysCount} Additional locked leads</span> last month </div>
        <div className={styles.unlockBoosterLeadsTooltipTxt}>These lead on your listing were locked because you do not have active booster package </div>
        <div className={styles.unlockBoosterLeadsTooltipTxt}>To get these {last30DaysCount} locked leads <span className={styles.TextSemibold}>next 30 days</span> </div>
        <span className={styles.unlockBoosterLeadsTooltipCta} onClick={() =>openUrl()}>Buy Monthly Subscription</span>
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    // snackbarData: state.snackbar,
    // theme:state.theme.isLightMode
    user: state.user.data,
  };
};

export default connect(mapStateToProps)(UnlockBoosterLeadsTooltip);
